import bgSection1 from 'assets/video/v005.mp4';
import imgSection2 from 'assets/img/main/v02.jpg';
import imgSection3 from 'assets/img/main/v03.jpg';
import imgSection4 from 'assets/img/main/v04.jpg';
import imgSection5 from 'assets/img/main/v05.jpg';
import bgSection6 from 'assets/video/v003.mp4';
// 
import programImg1 from 'assets/img/main/program_list_img01.jpg';
import programImg2 from 'assets/img/main/program_list_img02.jpg';
import programImg3 from 'assets/img/main/program_list_img03.jpg';
// 
import meritImg1 from 'assets/img/main/merit_icon01.jpg';
import meritImg2 from 'assets/img/main/merit_icon02.jpg';
import meritImg3 from 'assets/img/main/merit_icon03.jpg';
// 
import mediaImg1 from 'assets/img/main/media1.jpg';
// 
import arrowCommon from 'assets/img/main/notice_arrow_btn.jpg';
// 
import footerLogo from 'assets/img/common/foot_center_logo.png';
import footerLogoGray from 'assets/img/common/logo_gray.png';
import footerInsta from 'assets/img/common/foot_right_util_insta.png';
import footerIcon1 from 'assets/img/common/foot_right_util_icon01.jpg';
import footerIcon2 from 'assets/img/common/foot_right_util_icon02.jpg';
import footerIcon3 from 'assets/img/common/foot_right_util_icon03.jpg';
import footerIcon4 from 'assets/img/common/foot_right_util_icon04.jpg';
import goToTop from 'assets/img/common/go_to_top.png';
// 
import loadingIcon from 'assets/img/common/loading.svg';
import btnMore from 'assets/img/common/moreview_2x.png';



const Globals = {
    BG_SECTION1: bgSection1,
    IMG_SECTION2: imgSection2,
    IMG_SECTION3: imgSection3,
    IMG_SECTION4: imgSection4,
    IMG_SECTION5: imgSection5,
    BG_SECTION6: bgSection6,
    PROGRAM_IMG1: programImg1,
    PROGRAM_IMG2: programImg2,
    PROGRAM_IMG3: programImg3,
    MERIT_IMG1: meritImg1,
    MERIT_IMG2: meritImg2,
    MERIT_IMG3: meritImg3,
    MEDIA_IMG1: mediaImg1,
    NOTICE_ARROW: arrowCommon,
    FOOTER_LOGO: footerLogo,
    FOOTER_LOGO_GRAY: footerLogoGray,
    FOOTER_INSTA: footerInsta,
    FOOTER_ICON1: footerIcon1,
    FOOTER_ICON2: footerIcon2,
    FOOTER_ICON3: footerIcon3,
    FOOTER_ICON4: footerIcon4,
    GOTOTOP: goToTop,
    LOADING_ICON: loadingIcon,
    BTN_MORE: btnMore,
}

export default Globals;